import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import styled from 'styled-components'
import arrowDown from '../../../../assets/certificates/AddCertificate/arrow-down.svg'
import calendar from '../../../../assets/calendar-icon.svg'
import { devices } from '../../../../globalStyle'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  width: 80%;
`
export const GridContainer = styled.div`
  display: grid;
  grid-template-areas:
    'titleNew titleNew titleNew titleNew titleNew'
    'client type date readyToShip orderNumber'
    'line line line line line'
    'titleAdd titleAdd titleAdd titleAdd titleAdd'
    'cep street street neighborhood neighborhood'
    'number state city complement complement'
    'line2 line2 line2 line2 line2'
    'titleLoad titleLoad titleLoad titleLoad titleLoad'
    'height width length cubage cubage'
    'weight detail detail detail detail'
    'line3 line3 line3 line3 line3'
    'observation observation observation observation observation';
  
  gap: 1rem;
  border: 1px dashed #ccc; 
  grid-template-columns: repeat(4, minmax(200px, 1fr));
  grid-template-rows: auto; 
  padding: 1rem; 
  gap: 0rem; 
`
export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  
  margin-top: 2.8vh;
  margin-left: 1.2vw;
  margin-right: 0.7vw;
`

export const OptionsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-area: options;
  height: 2rem;
  padding-right: 1rem;
  margin-top: 1vw;
  margin-bottom: 1vw;
`
export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const LineDiv = styled.div`
  background: #ebebeb;
  
  height: 0.1px;
  grid-area: line;

  margin-top: 0.5vw;
`
export const ConformityStatus = styled.div<{ isvalue?: boolean }>`
  ${(props) =>
    props.isvalue
      ? `
    background-color: #fffcee0;
    color: #b30707;
  `
      : `
    color: #67C97E;
    background-color:rgba(179, 228, 191, 0);
  `}
  padding: .2rem .2rem;
  border-radius: 2rem;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 400;
  width: 10%;
  height: 70%;
  margin-left: 0.5rem;
  user-select: none;
`

export const InputDiv = styled.div`
  margin-left: 0.92rem;
  margin-top: 0.7rem;
  position: relative;
  align-items: flex-end;
  .empty {
    border: 0;
  }

  .isDisabled {
    cursor: not-allowed;
  }

  &.client {
    gap: 0.5rem;
    align-items: flex-end;
    width: 100%;
  }
  &.type {
    gap: 0.5rem;
    align-items: flex-end;
    width: 100%;
  }
`
export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`

export const CenterItensContainer = styled.div`
  display: flex;
  height: 2rem;
  align-items: center;
`
export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.7rem, calc(0.7rem + 0.1vw), 1.5rem);
`

export const Input = styled.input`
  width: 9.5vw;
  height: 2.2rem;
  background-color: #ebebeb;
  border: 0;
  border-radius: 2vw;
  margin-top: 0.8vh;
  margin-right: 1vh;
  padding-left: 1vw;
  padding-right: 1vw;
  font-size: 1rem;
  width: 100%;
  color: #696969;
  :focus {
    outline: 0;
  }
  ::placeholder {
    color: #999;
    font-style: italic;
  }
`

export const StyledSelect = styled.select`
  background-color: #ebebeb;
  color: #777777;
  height: 2.2rem;
  width: 60%;
  font-size: clamp(0.6rem, calc(0.6rem + 0.1vw), 1.3rem);
  margin-top: 0.45rem;
  padding-left: 0.92rem;
  padding-right: 2.15rem;
  border-radius: 1.78rem;
  border: 1px solid #e1e1e1;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${arrowDown});
  background-repeat: no-repeat;
  background-position-x: 10.1rem;
  background-position-y: 0.7rem;
  background-size: 1.2rem;

  :focus {
    outline: 0;
  }

  @media (max-width: 2000px) {
    width: 12.2rem;
    background-position-x: 13;
  }
  @media (max-width: 1900px) {
    width: 12.2rem;
    background-position-x: 10.5rem;
  }

  @media (max-width: 960px) {
    width: 9.8rem;
  }

  @media (max-width: 720px) {
    width: 7.2rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
  }

  &.client {
    width: 15vw;
    background-position-x: 12rem;
    background-position-y: 0.7rem;
    background-size: 1.2rem;
    @media (min-width: 2000px) {
      width: 20rem;
      background-position-x: 18rem;
    }
  }
`
export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #ebebeb;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;

  @media (max-width: 2000px) {
    width: 12.2rem;
    background-position-x: 13;
  }
  @media (max-width: 1900px) {
    width: 12.2rem;
    background-position-x: 10.5rem;
  }

  @media (max-width: 960px) {
    width: 9.8rem;
  }

  @media (max-width: 720px) {
    width: 7.2rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
  }

  &.client {
    width: 15vw;
    background-position-x: 12rem;
    background-position-y: 0.7rem;
    background-size: 1.2rem;
    @media (min-width: 2000px) {
      width: 19rem;
      background-position-x: 18rem;
    }
  }
`
export const StyledDate = styled.input`
  background-color: #ebebeb;
  color: #777777;
  height: 2.2rem;
  width: 13rem;
  font-size: 1rem;
  margin-top: 0.45rem;
  padding-left: 0.92rem;
  padding-right: 2.15rem;
  border-radius: 1.78rem;
  border: 1px solid #e1e1e1;
  -webkit-appearance: none;
  -moz-appearance: none;

  ::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 8.5rem;
    position: absolute;
    right: 0;
    top: 0;
    width: 5rem;
  }

  background-image: url(${calendar});
  background-repeat: no-repeat;
  background-position-x: 9.1rem;
  background-position-y: -0.5rem;
  background-size: 3rem;

  :focus {
    outline: 0;
  }

  ::placeholder {
    color: #999;
  }

  @media (max-width: 1920px) {
    width: 12.2rem;
  }

  @media (max-width: 960px) {
    width: 9.8rem;
  }

  @media (max-width: 720px) {
    width: 7.2rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
  }
`

export const StyledOption = styled.option`
  background-color: #fff;
  height: 0.7rem;
  font-size: clamp(0.5rem, calc(0.6rem + 0.1vw), 1.3rem);
`

export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  cursor: pointer;
  padding: 0.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 10vw;
  }

  &.reverse {
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`

export const PlusImg = styled.img`
  display: flex;
  height: 1.5vw;
  margin-right: 0.5vw;

  @media ${devices.largeDesktop} {
    height: 1vw;
  }
`

export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse {
    color: #0090d3;
  }
`
